<div class="legend-container" *ngIf="!!dataSource.length">
  <div class="legend-item" (click)="filterByLegend('impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'impact drivers'">
    <div class="legend-color-box" style="background-color: var(--dvm-table-common-bg, #DCEAF7);"></div>
    <span>Impact drivers</span>
  </div>
  <div class="legend-item" (click)="filterByLegend('non-impact drivers')"
    [class.active]="activeLegend?.toLowerCase() === 'non-impact drivers'">
    <div class="legend-color-box" style="background-color: var(--dvm-table-non-common-bg, #f2f2f2);"></div>
    <span>Non Impact drivers</span>
  </div>
</div>
<div class="card  table-wrapper" [style.height]="containerHeight">
  <div class="table-spinner-overlay" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="table-state error" *ngIf="!isLoading && errorMessage">
    {{ errorMessage }}
  </div>

  <div class="table-state" *ngIf="!isLoading && !errorMessage && !treeLayout && !dataSource.length">
    {{ data?.noDataText || 'No data available.' }}
  </div>

  <div class="tree-table-container" [style.height]="containerHeight" [style.--tree-row-height.px]="treeRowHeightPx" *ngIf="treeLayout as tl">
    <table class="tree-table" [style.--tree-row-count]="treeRowCount">
      <tr>
        <th class="tree-left-header">{{ tl.topLeftLabel }}</th>
        <th class="tree-top-header" [attr.colspan]="tl.totalLeafColumns">{{ tl.topHeaderValue }}</th>
      </tr>
      <tr>
        <th class="tree-left-header">{{ tl.groupRowLabel }}</th>
        <th class="tree-sub-header" *ngFor="let grp of tl.groupHeaders" [attr.colspan]="grp.span">{{ grp.label }}</th>
      </tr>
      <tr>
        <th class="tree-left-header">{{ tl.itemRowLabel }}</th>
        <th class="tree-leaf-header" *ngFor="let item of tl.itemHeaders; let colIdx = index" (click)="onTreeLeafClick(colIdx)">{{ item }}</th>
      </tr>
      <tr>
        <th class="tree-left-header">{{ tl.subItemRowLabel }}</th>
        <th class="tree-leaf-header" *ngFor="let sub of tl.subItemHeaders; let colIdx = index" (click)="onTreeLeafClick(colIdx)">{{ sub }}</th>
      </tr>

      <tr *ngFor="let metric of tl.metricRows">
        <th class="tree-left-header tree-metric-label">{{ metric.label }}</th>
        <td class="tree-cell" *ngFor="let val of metric.values; let colIdx = index" (click)="onTreeLeafClick(colIdx)">{{ val }}</td>
      </tr>
    </table>
  </div>

  <div [ngClass]="{'table-container': !data?.isPagination, 'freeze-column-enabled': data?.freezeColumn}" [style.height]="containerHeight" *ngIf="!treeLayout && !!dataSource.length">
    <table mat-table [dataSource]="data?.isPagination ? pagedData : dataSource">
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th class="tableheader" mat-header-cell *matHeaderCellDef
            [class.frozen-col]="isFrozenColumn(column)"
            [class.frozen-col-last]="isLastFrozenColumn(column)"
            [class.no-freeze-row]="data?.freezeRow === false"
            [class.collapsed-col-header]="isColumnCollapsed(column)"
            [class.column-divider]="showDivider(column)"
            [style.left.px]="getFrozenColumnLeft(column)"
            (click)="isColumnCollapsed(column) ? toggleColumnCollapse(column, $event) : null">
          <div class="header-content" *ngIf="!isColumnCollapsed(column)">
            <span class="header-label">{{ columnLabels[column] }}</span>
            <span class="collapse-col-toggle"
              (click)="toggleColumnCollapse(column, $event)"
              title="Collapse column">&#9664;</span>
          </div>
          <span class="collapsed-col-label" *ngIf="isColumnCollapsed(column)"
            [title]="'Expand ' + columnLabels[column]">{{ columnLabels[column] }}</span>
        </th>
        <td class="tablebody" mat-cell *matCellDef="let row"
            [class.frozen-col]="isFrozenColumn(column)"
            [class.frozen-col-last]="isLastFrozenColumn(column)"
            [class.collapsed-col-cell]="isColumnCollapsed(column)"
            [class.column-divider]="showDivider(column)"
            [style.left.px]="getFrozenColumnLeft(column)"
            (click)="onFlatTableCellClick(row)">
          <span *ngIf="!isColumnCollapsed(column)">{{ row[column] }}</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
        [style.--frozen-row-top.px]="getFrozenBodyRowTop(i)"
        [style.--frozen-row-bottom.px]="getFrozenBodyRowBottom(i)"
        [ngClass]="{
      'frozen-body-row': isFrozenBodyRow(i),
      'common-background': row.option_impact_drivers?.toLowerCase() === 'impact drivers',
      'non-common-background': row.option_impact_drivers?.toLowerCase() === 'non-impact drivers'
    }">
      </tr>

    </table>
    @if (!treeLayout && !!data?.isPagination && !!dataSource.length ) {
    <app-paginator (pageChange)="onPageChange($event)" #paginatorComp></app-paginator>
    }
  </div>
</div>
